import './WebservicePage.scss';

function WebservicePage() {
  const wssHostLink = 'https://developer.cap.co.uk/webservices';
  const downloadHash = '#Data%20Download';

  return (
    <div className='webservice-page-container'>
      <section>
        <h2 className='headerText'>Data via Web Services</h2>
        <p>
          CSV, JSON and Published database require the customer to store the data themselves,
          however Customers are able to subscribe to CAP data Web Services
          if they want to use the data direct from our servers,
          cutting down on the need to store and host data themselves.
        </p>
        <p>
          CAP host a number of Web Services which customers can subscribe to (by data set/database),
          allowing them to request individual pieces of data, or data bundles for individual vehicles.
        </p>
        <p>
          Explanations, examples and the typical response is shown for each web service on screen and
          again developers familiar with web services would be able to write their own scripts to
          access/use these services to automate the downloads.
        </p>
        <p>
          All web services are hosted by <a href={wssHostLink} target='_blank'>{wssHostLink}</a>,
          which also provides full developer documentation.
        </p>
        <p>
          Data updated daily or monthly dependant on subscription.
        </p>
      </section>

      <section>
        <h2>Download via Web Services</h2>
        <p>
          As an alternate method to download data
          customers can use web services to pull the data package (.exe file) from our website.
        </p>
        <p>
          Customers are able to use the web services described on this page to access information about their subscriptions
          or download the data files themselves.
        </p>
        <p>
          Developers familiar with web services would be able to write their own scripts to
          access/use these services to automate the download.
        </p>
        <p>
          Explanations, examples and the typical response are shown for each web service on screen.
        </p>
        <p>
          Full developer documentation can be found <a href={wssHostLink + downloadHash} target='_blank'>here</a>.
        </p>
      </section>
    </div>
  );
}

export default WebservicePage;